//const PASSWORD_REGEX = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%!]).{9,20})$/i;
// 'Password should include at least 9 characters and must contain at least one Lower and one Upper case letter, one digit and one special character.';

export const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = "Name can't be empty";
  }

  if (!values.email) {
    errors.email = "Email can't be empty";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Invalid email address';
  }

  if (!values.password || values.password.length < 6) {
    errors.password = 'Password should include at least 6 characters';
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = 'Please confirm your password';
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = 'Password mismatched';
  }

  if (!values.appName) {
    errors.appName = 'App name is required';
  } else if (!/^[a-zA-Z0-9]+[a-zA-Z0-9-_]*[a-zA-Z0-9]$/i.test(values.appName)) {
    errors.appName =
      'App name should only contain numbers and characters. You can use dashes and underscores, as long as they are not in the start or end of the app name.';
  }

  if (!values.confirmAgreement) {
    errors.confirmAgreement = 'Please confirm agreement';
  }

  return errors;
};

export const sanitazeMessage = message => {
  if (message && message[0] === '[') {
    message = message.substring(1, message.length - 1);
  }
  return message;
};



// WEBPACK FOOTER //
// ./src/utils/form.js